/* HaPairRenderer.js */

"use strict";
const _ = require("lodash");
class HaPairRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("ha-pair-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._rootElem.addEventListener(
            "click",
            (this._onOpenDevices = _.debounce(_.bind(this._onOpenDevices, this), 3000, {
                maxWait: 3000,
                leading: true,
                trailing: false
            }))
        );
        this._model.on("SetHaGroup", (this._onHaGroup = this._onHaGroup.bind(this)));
    }

    _unregisterListeners() {
        this._rootElem.removeEventListener("click", this._onOpenDevices);
        this._model.removeAllListeners("SetHaGroup");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setPairedName(this._model.getValue());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onHaGroup(newValue) {
        this._setPairedName(newValue);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setPairedName(value) {
        if (value) {
            this._rootElem.innerHTML = value;
        } else {
            this._rootElem.innerHTML = "";
        }
    }
    _onOpenDevices() {
        this._model.getPairedDevice().then((id) => {
            if (id) {
                this._model.openEditor(id);
            }
        });
    }
    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = HaPairRenderer;
